import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';
import { RelatedEntityTypeEnum, UserType } from '@/types/schema';

import { ActionDialogsEnum, InViewDialogState } from '../../types';
import { DashboardProps } from '../TaskDashboard/types';
import AddClient from './AddClient';
import AddClientContact from './AddClientContact';
import AddNewTask from './AddNewTask';
import ConvertTaskToSubtask from './ConvertTaskToSubtask';
import DeleteClient from './DeleteClient';
import DeleteList from './DeleteList';
import DeleteProject from './DeleteProject';
import { DeleteSection } from './DeleteSection';
import DeleteTask from './DeleteTask';
import DuplicateList from './DuplicateList';
import DuplicateProject from './DuplicateProject';
import DuplicateTask from './DuplicateTask';
import EditTask from './EditTask';
import FolderEditor from './FolderEditor';
import ListEditor from './ListEditor';
import MoveTaskToList from './MoveTaskToList';
import MoveTaskToProject from './MoveTaskToProject';
import MoveToSection from './MoveToSection';
import ProjectEditor from './ProjectEditor';
import RemoveTask from './RemoveTask';
import SectionEditor from './SectionEditor';

const MAPPED_DIALOG = {
  [ActionDialogsEnum.DeleteProject]: DeleteProject,
  [ActionDialogsEnum.DuplicateProject]: DuplicateProject,
  [ActionDialogsEnum.DeleteTask]: DeleteTask,
  [ActionDialogsEnum.RemoveTask]: RemoveTask,
  [ActionDialogsEnum.CreateFolder]: FolderEditor,
  [ActionDialogsEnum.CreateProject]: ProjectEditor,
  [ActionDialogsEnum.EditProject]: ProjectEditor,
  [ActionDialogsEnum.AddNewTask]: AddNewTask,
  [ActionDialogsEnum.DuplicateTask]: DuplicateTask,
  [ActionDialogsEnum.ConvertTaskToSubtask]: ConvertTaskToSubtask,
  [ActionDialogsEnum.EditTask]: EditTask,
  [ActionDialogsEnum.CreateList]: ListEditor,
  [ActionDialogsEnum.EditList]: ListEditor,
  [ActionDialogsEnum.DeleteList]: DeleteList,
  [ActionDialogsEnum.DuplicateList]: DuplicateList,
  [ActionDialogsEnum.CreateSection]: SectionEditor,
  [ActionDialogsEnum.EditSection]: SectionEditor,
  [ActionDialogsEnum.MoveToSection]: MoveToSection,
  [ActionDialogsEnum.DeleteSection]: DeleteSection,
  [ActionDialogsEnum.AddOrEditClient]: AddClient,
  [ActionDialogsEnum.DeleteClient]: DeleteClient,
  [ActionDialogsEnum.AddClientContact]: AddClientContact,
  [ActionDialogsEnum.MoveTaskToList]: MoveTaskToList,
  [ActionDialogsEnum.MoveTaskToProject]: MoveTaskToProject,
};

function ActionDialogs({
  inViewDialogState,
  onClose,
  inViewFileId,
  entity,
  entityId,
  defaultAssigneeId,
  participants,
  onRefetchParentProgress,
  onViewTask,
}: {
  inViewDialogState?: InViewDialogState;
  onClose: (props?: { refetchData?: boolean }) => void;
  inViewFileId?: string;
  entityId?: string;
  entity?: RelatedEntityTypeEnum;
  defaultAssigneeId?: string;
  participants?: UserType[];
  onRefetchParentProgress?: DashboardProps['onRefetchParentProgress'];
  onViewTask?: (taskId: string, taskData?: ActionItemFragment[]) => void;
}) {
  if (!inViewDialogState) {
    return null;
  }

  const { dialog, ...props } = inViewDialogState;
  const ActionComp = MAPPED_DIALOG[dialog];

  return (
    <ActionComp
      {...props}
      defaultAssigneeId={defaultAssigneeId}
      entity={entity}
      entityId={entityId}
      inViewFileId={inViewFileId}
      participants={participants}
      onClose={onClose}
      onRefetchParentProgress={onRefetchParentProgress}
      onViewTask={onViewTask}
    />
  );
}

export default ActionDialogs;
